import { createTracker } from 'usage-tracker';
const tracker = createTracker({
  standalone: true,
  lastKnownEventProperties: ['screen']
});
const trackEvents = (eventName, eventKey, options) => {
  tracker.track('Meetings', eventName, Object.assign({
    action: eventKey
  }, options));
};
export function trackSubScreen(subscreen) {
  trackEvents('Meetings', 'Pageview', {
    action: 'pageViewSubScreen',
    screen: 'admin',
    subscreen
  });
}
export function trackUserInteraction(action) {
  trackEvents('Meetings', 'User Interaction', {
    action
  });
}
export default tracker;